export default "__VITE_ASSET__DHSy6GyN__"